<template>
  <MainWrapper>
      <div class="companies-control-panel mb-30">
          <div class="container">
              <div class="row">
                  <div class="col-lg-12">
                      <div class="companies-control-panel-inner">
                          <router-link to="/specialist/settings" class="mr-20">
                              <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                              <span class="dark-body-text panel-body-text">Основные настройки</span>
                          </router-link>
                          <router-link to="/specialist/settings/schedule" class="mr-20">
                              <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'cog']" />
                              <span class="dark-body-text panel-body-text">Настройки расписания</span>
                          </router-link>
                          <router-link :to="'/specialist/calendar'" class="mr-20">
                              <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'calendar-alt']" />
                              <span class="dark-body-text panel-body-text">Календарь</span>
                          </router-link>
                          <router-link to="/specialist/reservations" class="mr-20">
                              <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'calendar-check']" />
                              <span class="dark-body-text panel-body-text">Все записи</span>
                          </router-link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    <div class="single-master-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="schedule-controls mb-20">
                        <!--
                        <div class="button-left animated-shadow pointer round-button mr-10" @click="prevWeek">
                            <font-awesome-icon class="icon" :icon="['fal', 'angle-left']" />
                        </div>
                        <div class="button-right animated-shadow pointer round-button mr-30" @click="nextWeek">
                            <font-awesome-icon class="icon" :icon="['fal', 'angle-right']" />
                        </div>
                        -->
                        <div class="input-wrapper mr-15">
                            <input v-model="startDay" class="rounded-input" type="date" />
                        </div>
                        <div class="input-wrapper mr-15">
                            <input v-model="endDay" class="rounded-input" type="date" />
                        </div>
                        <div class="live-query-button-wrapper mr-15">
                            <input v-model="client" class="rounded-input" type="text" placeholder="ФИО клиента" />
                        </div>
                        <div class="live-query-button-wrapper mr-15">
                            <Button text="Применить" icon="check" @click="getSpecReservations" />
                        </div>
                        <div class="live-query-button-wrapper">
                            <Button text="Живая очередь" @click="specModal = true; chosenDay = todayDay; registrator = true; live = true;" />
                        </div>
                        <!--
                        <div class="live-query-button-wrapper mr-15">
                            <Button text="Напечатать" icon="print" />
                        </div>
                        -->
                        <!--
                        <div class="live-query-button-wrapper pull-right">
                            <input class="rounded-input" type="text" placeholder="Найти" />
                        </div>
                        -->
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="white-panel">
                        <div class="container-fluid">
                            <div class="row mb-5 table-header">
                                <div class="col-lg-3 pt-20 pl-20 pr-20 pb-20">
                                    Время записи
                                    <!--<p class="desc mt-5">{ description }</p>-->
                                </div>
                                <div class="col-lg-3 pt-20 pl-20 pr-20 pb-20">
                                    Клиент
                                    <!--<p class="desc mt-5">{ description }</p>-->
                                </div>
                                <div class="col-lg-3 pt-20 pl-20 pr-20 pb-20">
                                    Компания
                                    <!--<p class="desc mt-5">{ description }</p>-->
                                </div>
                                <div class="col-lg-2 pt-20 pl-20 pr-20 pb-20">
                                    Тип записи
                                    <!--<p class="desc mt-5">{ description }</p>-->
                                </div>
                                <!--
                                <div class="col-lg-2 pt-20 pl-20 pr-20 pb-20">
                                    Действия
                                </div>
                                -->
                            </div>
                            <div v-if="orders.length > 0" class="row" v-for="ord in orders" :key="ord.id">
                                <!--div style="width:70px">
                                    <div class="mt-15 mb-15">
                                        <div class="single-filter">
                                            <div v-if="ord.status === 'confirmed'" class="filter-icon">
                                                <font-awesome-icon class="icon" :icon="['fal', 'calendar-check']" style="width:24px;height:24px;color:#27AE60" />
                                            </div>
                                            <div v-if="ord.status === 'armored'" class="filter-icon">
                                                <font-awesome-icon class="icon" :icon="['fal', 'calendar-plus']" style="width:24px;height:24px;color:#F2C94C" />
                                            </div>
                                            <div v-if="ord.status === 'success'" class="filter-icon">
                                                <font-awesome-icon class="icon" :icon="['fal', 'calendar-alt']" style="width:24px;height:24px;color:#2F80ED" />
                                            </div>
                                            <div v-if="ord.status === 'refused'" class="filter-icon">
                                                <font-awesome-icon class="icon" :icon="['fal', 'calendar-times']" style="width:24px;height:24px;color:#EB5757" />
                                            </div>
                                        </div>
                                    </div>
                                </div-->
                                <div class="col-lg-3">
                                    <font-awesome-icon v-if="ord.status === 'confirmed'" class="icon" :icon="['fal', 'calendar-check']" style="display:inline-block;width:24px;height:24px;color:#27AE60" />
                                    <font-awesome-icon v-if="ord.status === 'armored'" class="icon" :icon="['fal', 'calendar-plus']" style="display:inline-block;width:24px;height:24px;color:#F2C94C" />
                                    <div class="ml-15 mt-15 mb-15" style="display:inline-block">
                                        <span>Запись от</span><br>
                                        <strong>{{ ord.created_at }}</strong>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="dark-body-text mt-15">{{ ord.client_name }}, {{ ord.phone }}</div>
                                    <div class="mb-15">{{ ord.service }}</div>
                                </div>
                                <div class="col-lg-3">
                                    <div v-if="ord.master_name !== specInfo.full_name" class="dark-body-text mt-15 mb-15">{{ ord.master_name }}</div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="mt-15 mb-15">
                                        <span v-if="ord.live === true">Живая очередь</span>
                                        <span v-else="">По записи</span>
                                        <br><span>на <strong>{{ ord.date_time_reservation }}</strong></span>
                                    </div>
                                </div>
                                <div class="col-lg-1">
                                    <div class="mt-15 mb-15">
                                        <div class="single-filter pull-right">
                                            <div v-if="ord.status === 'armored'" class="filter-icon">
                                                <font-awesome-icon class="mr-10 admin-order-change-icons-single" :icon="['fal', 'check-circle']" @click="updateStatus(ord.id, 'confirmed')" style="cursor:pointer;width:24px;height:24px;color:#27AE60" />
                                            </div>
                                            <div class="filter-icon">
                                                <font-awesome-icon class="mr-10 admin-order-change-icons-single" :icon="['fal', 'times-circle']" style="width:24px;height:24px;color:#EB5757" />
                                            </div>
                                            <!--
                                            <span v-if="ord.status === 'armored'">Забронировано</span>
                                            <span v-if="ord.status === 'confirmed'">Подтвержден</span>
                                            <span v-if="ord.status === 'success'">Выполнено</span>
                                            <span v-if="ord.status === 'refused'">Отказано</span>
                                            -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="orders.length === 0" class="row">
                                <div class="col-lg-12">
                                    <p class="mt-15 mb-15" style="text-align:center">Нет данных</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
      <RegisterTimeModal :date="chosenDay" :opened="specModal" v-on:reservation-created="reservationCreatedHandler" v-on:close-it="specModal = false" :org="chosenCompany" :specialist="this.specialist" :services="this.services" v-on:choose-sect="(i) => this.chosenService = i" :periods="this.periods" :registrator="this.registrator" :live="this.live"></RegisterTimeModal>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
    /* @import '../styles/main.core.vars.styl'; */

    .single-filter
        display: inline-flex
        align-items: center
        .filter-icon
            width: 38px
            height: 38px
            display: inline-flex
            align-items: center
            justify-content: center
            border-radius: 100%

    .table-header
        background: radial-gradient(722.67px at 77.85% 86.89%, #1BEFDC 0%, #24CEDA 100%)
        color: #fff
        text-transform: uppercase
        font-weight: 700
        font-size: 13px

    .white-panel
        overflow: hidden;

    .desc
        font-weight: 400
        text-transform: none

    .spec-categories
        padding: 20px 60px 30px 20px

    .spec-categories-header
        display: flex
        .spec-count
            margin: 0 0 0 auto
            color: $gray_text

    .spec-categories-single
        display: flex
        align-items: center
        >.icon
            margin-left: auto
            font-size: 16px

    .companies-control-panel
        margin-top: -30px
        height: 56px
        background: $black_text
        .panel-body-text, .panel-icon
            color: #fff
        .panel-icon
            font-size: 16px
        &-inner
            height: 56px
            display: flex
            align-items: center
            >div
                display: flex
                align-items: center
        input
            width: 430px

    .col-lg-1
        min-height: 0

    .arr-down
        position: absolute
        bottom: -2px
        width: 0
        height: 0
        border-left: 9px solid transparent
        border-right: 9px solid transparent
        border-bottom: 9px solid $black_text
        z-index: 4
        left: 0
        right: 0
        margin: auto

    .pull-right
        margin-left: auto

    .schedule-controls
        display: flex
        align-items: center
    
</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import Specialist from '@/components/Specialist.vue';
    import Paginator from '@/components/Paginator.vue';
    import RegisterTimeModal from '@/components/modals/RegisterTimeModal.vue';
    import moment from 'moment';
    import http from '@/methods/http.ts';

    @Component({
        components: {
            MainWrapper,
            Button,
            Specialist,
            Paginator,
            //ScheduleAdmin,
            RegisterTimeModal
        }
    })
    export default class CompanyAdmin extends Vue {

        moment = moment;
        todayDay = moment().format('DD.MM.YYYY');
        specModal = false;
        chosenCompany = {
            owner: ''
        };
        chosenDay = moment().format('DD.MM.YYYY');

        registrator = false;
        live = false;

        client = '';

        cutBuffer = false;
        copyBuffer = false;

        specialist_slug = '';

        specialist = {};
        services = {};
        periods = [];

        specInfo = {
            rating: 0,
            categories: [],
        };

        orders = [];

        zcolors= [];
        colors = [
            '#2F80ED',
            '#F2C94C',
            '#ddd',
            '#eee',
        ];

        confirmCanseled = false;

        confirmCanseledData = {
            'id': '',
            'service': '',
            'client_name': '',
            'comment': ''
        };

        cancelBuffer() {
            if (this.cutBuffer === true) {
                this.cutBuffer = false;
                this.$refs.calendar.cutBuffer = false;
            }
            if (this.copyBuffer === true) {
                this.copyBuffer = false;
                this.$refs.calendar.copyBuffer = false;
            }
        }

        nextWeek() {
            this.$refs.calendar.ordersFillData = [];
            this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
            .add(7, "d")
            .format("DD.MM.YYYY");

            let myDate = this.firstDay;
            myDate = myDate.split(".");
            this.teleportDay = myDate[2]+"-"+myDate[1]+"-"+myDate[0];
        }

        prevWeek() {
            /*
            var myDate = this.firstDay;
            myDate = myDate.split(".");
            var newDate = myDate[1]+"/"+myDate[0]+"/"+myDate[2];
            var stepDay = Math.floor(new Date(newDate).getTime() / 1000);
            myDate = moment().format("DD.MM.YYYY");
            myDate = myDate.split(".");
            var newDate = myDate[1]+"/"+myDate[0]+"/"+myDate[2];
            var todayDay = Math.floor(new Date(newDate).getTime() / 1000);

            if (stepDay <= todayDay) {
                return false;
            }
            */
            this.$refs.calendar.ordersFillData = [];
            this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
            .subtract(7, "d")
            .format("DD.MM.YYYY");

            let myDate = this.firstDay;
            myDate = myDate.split(".");
            this.teleportDay = myDate[2]+"-"+myDate[1]+"-"+myDate[0];
        }

        startDay = moment().format("YYYY-MM-DD");
        endDay = moment().format("YYYY-MM-DD");

        teleportSetTime() {
            var myDate = this.teleportDay.split("-");
            this.$refs.calendar.ordersFillData = [];
            this.firstDay = myDate[2]+"."+myDate[1]+"."+myDate[0];
        }

        getSpecInfo() {
            http(`masters/${this.specialist_slug}`, "get", false, {}).then(r => {
                this.specialist = r.data;
                this.services = r.data.service;
                this.chosenCompany.owner = '';
                this.specInfo = r.data;
                let owner_colors = [];
                let color_palette = this.colors;
                let i = 0;
                if (this.specInfo.company) {
                    this.specInfo.company.forEach(function (element) {
                        owner_colors[element.owner] = color_palette[i];
                        i++;
                    });
                    this.zcolors = owner_colors;
                }
            });
        }

        getUserInfo() {
            http('user/info', 'get', this.$store.state.token, {}).then(r => {
                this.specialist_slug = r.data.specialist_slug;
                this.getSpecInfo();
                this.getSpecReservations();
            })
        }

        getSpecReservations() {
            let url = 'masters/'+this.specialist_slug+'/reservations';
            let from = this.startDay.split("-");
            let to = this.endDay.split("-");
            http(url, 'get', this.$store.state.token, {
                status: this.status,
                sort: 'reservation_time_desc',
                from: from[2]+'.'+from[1]+'.'+from[0],
                to: to[2]+'.'+to[1]+'.'+to[0],
                client: this.client,
                live: true
            }).then(r => {
                this.orders = r.data;
                /*
                if (r.data.length > 0) {
                    let index, s_time, e_time, subindex;
                    moment.lang('ru');
                    r.data.forEach(function(element) {
                        index  = moment(element.date_time_reservation, 'DD.MM.YYYY HH:mm').format('DD MMMM YYYY');
                        s_time = moment(element.date_time_reservation, 'DD.MM.YYYY HH:mm').format('HH:mm');
                        e_time = moment(element.duration, 'HH:mm:ss').format('HH:mm');
                        e_time = moment(e_time, 'HH:mm').diff(moment().startOf('day'), 'seconds');
                        e_time = moment(element.date_time_reservation, 'DD.MM.YYYY HH:mm').add(e_time, 'seconds').format('HH:mm');
                        subindex = element.id;
                        info = {
                            'id': element.id,
                            'date': index,
                            'time': s_time + ' - ' + e_time,
                            'name': element.client_name,
                            'service': element.service,
                            'address': element.street_address,
                            'comment': element.comment,
                            'status': element.status
                        };
                        if (item_list[index]) {
                            item_list[index][subindex] = info;
                        } else {
                            item_list[index] = {[subindex]: info};
                        }
                    });
                }
                this.itemlist = item_list;
                this.itemlist_count = r.data.length;
                */
            })
        }

        reservationCreatedHandler() {
            this.getSpecReservations();
        }

        updateStatus(id, status) {
            http('reservation/update', 'post', this.$store.state.token, {
                id: id,
                status: status,
                comment: this.confirmCanseledData.comment
            }).then(r => {
                if (r.data.success === true) {
                    this.confirmCanseled = false;
                    this.$store.commit('notificate', { type: 'action', text: 'Запись обновлена' });
                    this.getSpecReservations();
                }
            }, error => {
                this.$store.commit('notificate', { type: 'alert', text: error.response.data.message });
            })
        }

        created() {
            this.getUserInfo();
        }


    }
</script>